// Import scripts
// Styles
import '../sass/main.scss';

// Import asset images
// import './images';

// Import javascript
// import debounce from './helpers/debounce';
import activeTrigger from './helpers/activeTrigger';

import siteNav from './components/siteNav';
import loadMore from './components/loadMore';
import swiper from './components/swiper';
import videos from './components/videos';
import firstSection from "./components/firstSection";
import masonry from "./components/masonry";

jQuery(document).ready(function () {
  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  activeTrigger();
  siteNav(jQuery);
  loadMore(jQuery);
  swiper();
  videos();
  firstSection(jQuery);
  masonry();
});